import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;

  border: 1px solid #a1a1a1;
  border-radius: 4px;

  background: #f2f2f2;

  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 20px;

  padding: 20px;
`;

export const HeaderContent = styled.div`
  display: grid;
  grid:
    "greeting link" min-content
    "message message" min-content
    / 1fr max-content;
  grid-gap: 12px;
  align-items: baseline;

  min-inline-size: 90px;
`;

export const Greeting = styled.span`
  grid-area: greeting;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 21px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
    line-height: 19px;
  }
`;

export const UserName = styled.span`
  font-weight: 700;
  word-break: break-all;
`;

export const Link = styled.a`
  grid-area: link;

  justify-self: flex-end;

  color: #4585ff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
  white-space: nowrap;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const Message = styled.div`
  grid-area: message;
`;

export const Content = styled.div`
  flex: 1;

  overflow: auto;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  min-block-size: 56px;

  background: #ededed;
`;

export const StyleScrollableContainer = css`
  scrollbar-width: thin;
  scrollbar-gutter: stable;
  &::-webkit-scrollbar {
    inline-size: 6px;

    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;

    background-color: #cccccc;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bbbbbb;
  }
`;
